import Vue from "vue";

export default new Vue({
  name:"menuKey",
  data(){
    return {
      
    }
  }
})




// WEBPACK FOOTER //
// ./src/mixins/menuBus.js